import { catchPromiseException } from '../utils/JsUtils';
import AbstractComponent from './AbstractComponent';
import Logger from '../utils/Logger';
import PhotoSwipe from 'photoswipe/dist/photoswipe.esm.js';
import PhotoSwipeLightbox from 'photoswipe/dist/photoswipe-lightbox.esm.js';
import Plyr from 'plyr';

export default class MediaGallery extends AbstractComponent {
    constructor(el, itemSelector, openCallback) {
        Logger.log('MediaGallery->constructor()');
        super(el);

        this.itemSelector = itemSelector;
        this.openCallback = openCallback;
        this.initDomElements();
        this.addEventListeners();
    }

    initDomElements() {
        this.initPhotoSwipeLightbox();
    }

    initPhotoSwipeLightbox() {
        this.photoSwipeLightbox = new PhotoSwipeLightbox({
            gallery: this.$el,
            children: this.itemSelector,
            counter: false,
            bgOpacity: 1,
            pswpModule: PhotoSwipe
        });

        if (this.photoSwipeLightbox) {
            this.photoSwipeLightbox.addFilter('itemData', (itemData, index) => {
                if (!itemData) {
                    return;
                }
                const element = itemData.element;
                if (!element) {
                    return;
                }
                const type = element.getAttribute('data-pswp-type');
                if (type) {
                    itemData.type = type;
                    itemData.w = 1920;
                    itemData.h = 1080;
                }
                const filmId = element.getAttribute('data-film-id');
                if (filmId) {
                    itemData.filmId = filmId;
                }
                const vimeoId = element.getAttribute('data-vimeo-video-id');
                if (vimeoId) {
                    itemData.vimeoId = vimeoId;
                }
                const vimeoVideoWidth = element.getAttribute('data-vimeo-video-width');
                if (vimeoVideoWidth) {
                    itemData.w = parseInt(vimeoVideoWidth);
                }
                const vimeoVideoHeight = element.getAttribute('data-vimeo-video-height');
                if (vimeoVideoHeight) {
                    itemData.h = parseInt(vimeoVideoHeight);
                }
                return itemData;
            });

            this.photoSwipeLightbox.on('contentLoad', (e) => {
                const { content } = e;
                if (content.data.type === 'film') {
                    e.preventDefault();
                    if (content.player) { return; }

                    content.element = document.createElement('div');
                    content.element.className = 'pswp__film-container';

                    const video = document.createElement('div');
                    video.setAttribute('id', 'film-player-' + content.data.filmId);
                    video.setAttribute('data-plyr-provider', 'vimeo');
                    video.setAttribute('data-plyr-embed-id', content.data.vimeoId);
                    content.element.appendChild(video);

                    const controls = ['play', 'progress', 'current-time', 'mute', 'volume', 'airplay', 'fullscreen'];
                    const options = {
                        controls: controls,
                        fullscreen: { iosNative: true }
                    };
                    content.player = new Plyr(video, options);
                }
            });

            this.photoSwipeLightbox.on('contentActivate', ({ content }) => {
                if (!content.player) { return; }
                if (content.player.ready) {
                    catchPromiseException(content.player.play());
                } else {
                    content.player.on('ready', () => catchPromiseException(content.player.play()));
                }
            });

            this.photoSwipeLightbox.on('contentDeactivate', ({ content }) => {
                if (!content.player) { return; }
                if (content.player.ready) {
                    catchPromiseException(content.player.pause());
                } else {
                    content.player.on('ready', () => catchPromiseException(content.player.pause()));
                }
            });

            this.photoSwipeLightbox.on('beforeOpen', () => {
                this.app.emit('media-gallery.open', this);
            });

            this.photoSwipeLightbox.on('close', () => {
                this.app.emit('media-gallery.close', this);
            });

            this.photoSwipeLightbox.init();
        }
    }

    addEventListeners() { }

    destroy() {
        if (this.photoSwipeLightbox) {
            this.photoSwipeLightbox.destroy();
        }
    }

    loadAndOpen(index) {
        if (this.photoSwipeLightbox) {
            this.photoSwipeLightbox.loadAndOpen(index, { gallery: this.$el });
        }
    }
}